import React from 'react'
import reactCSS from 'reactcss'
import { GithubPicker } from 'react-color'

class ColorPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayColorPicker: false,
      color: this.props.initialColor,
    };
    this.initialColors = [
      '#B80000',
      '#DB3E00',
      '#FCCB00',
      '#008B02',
      '#006B76',
      '#1273DE',
      '#004DCF',
      '#5300EB',
      '#EB9694',
      '#FAD0C3',
      '#FEF3BD',
      '#C1E1C5',
      '#BEDADC',
      '#C4DEF6',
      '#BED3F3',
      '#D4C4FB',
      '#000000',
      '#3B3B3B',
      '#666666',
      '#9B9B9B',
      '#A3A3A3',
      '#C9C9C9',
      '#D6D6D6',
      '#FFFFFF'
      ];
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChange = (color) => {
    this.setState({ color: color.hex });
    this.props.onChangeColor(color.hex);
  };

  render() {

    const styles = reactCSS({
      'default': {
        color: {
          width: '100%',
          height: '30px',
          borderRadius: '2px',
          background: this.state.color,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
          width: '100%',
          height: '40px'
        },
        popover: {
          width: '100%',
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
      <div>
        <div style={ styles.swatch } onClick={ this.handleClick }>
          <div style={ styles.color } />
        </div>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <GithubPicker color={ this.state.color } onChange={ this.handleChange } width={'213px'} colors={this.initialColors}/>
        </div> : null }

      </div>
    )
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./src/views/Components/ColorPicker.jsx